<div
  data-event="checkout"
  data-step="1"
  data-cart="{JSON.stringify([
    {
      id: '123 (article no)',
      name: 'productname',
      brand: 'productbrand',
      category: 'top level category',
      price: '123,89',
      quantity: '1',
    },
  ])}"
>
  <h1>Checkout step 1</h1>
  <p>Add data tags somewhere on page</p>
  <p>data-cart should contain a json string with the cart contents</p>
</div>
